import { useEffect, useState } from 'react';
import axios from 'axios';

export function usePaypalClientId() {
  const [clientId, setClientId] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/payments/paypal/config`)
      .then((r) => { setClientId(r.data.client_id); })
      .catch(() => { setClientId(null); });
  }, []);
  return clientId;
}
